/**
 * 定义所有API接口URL常量
 */

//全局API接口的URL,例如：http://127.0.0.1:8080
const GLOBAL_API_URL = process.env.VUE_APP_GLOBAL_API_URL;

//全局静态资源的URL,例如：http://127.0.0.1/static
const GLOBAL_STATIC_RESOURCE_URL =
    process.env.VUE_APP_GLOBAL_STATIC_RESOURCE_URL;

//平台服务API接口
class PlatformServiceApi {
    of(apiUrl) {
        return GLOBAL_API_URL + apiUrl;
    }
}

//平台静态资源接口
class PlatformStaticResource {
    of(staticUrl) {
        return GLOBAL_STATIC_RESOURCE_URL + staticUrl;
    }
}

/**
 * 默认的API接口调用出错handler
 * @param {*} error
 */
function defaultApiErrorHandler(error, callback) {
    let vue = window.app;
    if (this && this._isVue) {
        vue = this;
    }
    //如果error不存在则说明在axios的全局拦截器中被处理了
    if (error) {
        if (error.response) {
            let result = error.response.data;
            if (result && result.message) {
                vue.$message.error(result.message);
                if (typeof callback === 'function') {
                    callback.call(vue, result);
                }
            } else {
                vue.$message.error(vue.$i18n.t('message.request.failure'));
            }
        } else {
            vue.$message.error(vue.$i18n.t('message.request.failure'));
            console.error(error.message);
        }
    }
}

//登录API接口URL
const LOGIN_API_URL = '/api/login';

//登出API接口URL
const LOGOUT_API_URL = '/api/logout';

//注销API接口URL
const CANCEL_API_URL = '/api/cancel';

//登录续约API接口URL
const LOGIN_RENEWAL_API_URL = '/api/renewal';

//注册API接口URL
const REGISTER_API_URL_PATTERN = /^\/api\/register\/.*$/;

//不需要登录凭证即可访问的API接口(可以是确切的URL，或者是个正则表达式)
const EXCLUDE_AUTHORIZATION_API_URLS = [
    LOGIN_API_URL,
    REGISTER_API_URL_PATTERN
];

/**
 * API接口访问accessToken过期时间(默认2小时)
 */
const API_ACCESS_TOKEN_EXPIRATION_TIME = 7200;

/**
 * API接口访问accessToken提前刷新时间
 * 比如剩余有效期在10分钟以内则就需要提前刷新token了
 */
const API_ACCESS_TOKEN_PRE_REFRESH_TIME = 600;

//统一用户权限及认证授权平台的服务API接口
const PLATFORM_API = new PlatformServiceApi();

//统一用户权限及认证授权平台的服务API接口
const PLATFORM_STATIC_RESOURCE = new PlatformStaticResource();

/**
 * 判断一个url是否是需要认证的
 * @param {*} url
 */
function isAuthorizationRequiredUrl(url) {
    let excludesPatterns = EXCLUDE_AUTHORIZATION_API_URLS;
    for (let pattern of excludesPatterns) {
        if (pattern instanceof RegExp) {
            if (pattern.test(url)) {
                //console.log(`pattern url matched : pattern = ${pattern}, url = ${url}`);
                return false;
            }
        } else {
            if (pattern == url) {
                //console.log(`string url matched : pattern = ${pattern}, url = ${url}`);
                return false;
            }
        }
    }
    return true;
}

export {
    defaultApiErrorHandler,
    EXCLUDE_AUTHORIZATION_API_URLS,
    API_ACCESS_TOKEN_EXPIRATION_TIME,
    API_ACCESS_TOKEN_PRE_REFRESH_TIME,
    LOGIN_API_URL,
    LOGOUT_API_URL,
    CANCEL_API_URL,
    LOGIN_RENEWAL_API_URL,
    PLATFORM_API,
    PLATFORM_STATIC_RESOURCE,
    isAuthorizationRequiredUrl
};
